import { render } from "./TrfWizardModuloDataDeInicio.vue?vue&type=template&id=e089b34e&scoped=true"
import script from "./TrfWizardModuloDataDeInicio.vue?vue&type=script&lang=js"
export * from "./TrfWizardModuloDataDeInicio.vue?vue&type=script&lang=js"

import "./TrfWizardModuloDataDeInicio.vue?vue&type=style&index=0&id=e089b34e&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e089b34e"],['__file',"src/components/WizardConfiguracaoPendente/TrfWizardModuloDataDeInicio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e089b34e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e089b34e', __exports__)) {
    console.log('reload')
    api.reload('e089b34e', __exports__)
  }
  
  module.hot.accept("./TrfWizardModuloDataDeInicio.vue?vue&type=template&id=e089b34e&scoped=true", () => {
    console.log('re-render')
    api.rerender('e089b34e', render)
  })

}


export default __exports__